module.exports = __webpack_public_path__ + "static/media/forky.36f19092.jpg";